import { JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-api-endpoint',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <aside class="api-result endpoint-panel" aria-label="API endpoint">
      <div class="endpoint-line">
        <span>Endpoint</span>
        <code>{{ endpoint() }}</code>
      </div>
    </aside>
  `,
})
export class ApiEndpointComponent {
  readonly endpoint = input.required<string>();
}

@Component({
  selector: 'app-api-result',
  imports: [JsonPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (showEndpoint() || request() !== undefined || response() !== undefined || error() !== undefined) {
      <aside class="api-result" aria-live="polite">
        @if (showEndpoint()) {
          <div class="endpoint-line">
            <span>Endpoint</span>
            <code>{{ endpoint() }}</code>
          </div>
        }

        @if (error() !== undefined) {
          <details class="result-block result-error" open>
            <summary>Error response</summary>
            <pre>{{ error() | json }}</pre>
          </details>
        }

        @if (response() !== undefined) {
          <details class="result-block result-success" open>
            <summary>Response</summary>
            <pre>{{ response() | json }}</pre>
          </details>
        }

        @if (request() !== undefined) {
          <details class="result-block">
            <summary>Request body</summary>
            <pre>{{ request() | json }}</pre>
          </details>
        }
      </aside>
    }
  `,
})
export class ApiResultComponent {
  readonly endpoint = input.required<string>();
  readonly showEndpoint = input(true);
  readonly request = input<unknown | undefined>(undefined);
  readonly response = input<unknown | undefined>(undefined);
  readonly error = input<unknown | undefined>(undefined);
}